import { AfterViewInit, Component, Inject, OnDestroy, PLATFORM_ID } from '@angular/core';

import { isPlatformBrowser } from '@angular/common';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { NoWalletComponent } from '../../modals/no-wallet/no-wallet.component';
import { AnalyticsService } from '../../services/analytics.service';
import { PresaleDataService } from '../../services/connection-services/data.service';
import { EventService } from '../../services/event.service';
import { WINDOW } from '../../services/window';
import { CHAINS, getUserDevice, SwapStatus } from '../../shared/constants/app-enums';
import { getChainData } from '../../shared/constants/wallet-connect.const';
import { ICounter, RaisedInfo } from '../../shared/interfaces/common.interface';
import { IBalnceDataEVM, IBalnceDataSOL, ITokenomics } from '../../shared/interfaces/wallet.interface';
import { TranslateService } from '@ngx-translate/core';
import { PopupService } from '../../services/popup.service';
import { ClaimComponent } from '../../modals/claim/claim.component';
import { EvmPurchseService } from '../../services/evm-services/evm-purchase.service';

@Component({
  selector: 'app-widget',
  templateUrl: './widget.component.html',
  styleUrl: './widget.component.scss',
})
export class WidgetV2 implements AfterViewInit, OnDestroy {
  private subscriptions: Subscription[] = [];

  isBsNetwork: boolean = false;
  tokenSold = 0;
  maxAmount = 0;
  maxToken = 0;
  minToken = 0;
  usdRaised = 0;
  currentStep = 0;
  userStaked: number = 0;
  userClaimable: number = 0;
  userEthClaimable: number = 0;
  refreshId!: ReturnType<typeof setInterval>;
  refreshRate: number = 500;
  dataLoaded: boolean = false;
  salePrice: number = 0.0337;
  liveCounter: ICounter = { _days: 0, _hours: 0, _minutes: 0, _seconds: 0, _diff: 0 };
  swapMode: string = 'native';
  isNative: boolean = true;
  isWert: boolean = false;
  referUrl: string = '';
  SwapStatus = SwapStatus;
  timeInterval!: ReturnType<typeof setInterval>;
  // communityPhaseCountDown = 1773064800000;

  walletAddress!: string;
  currentStoreData!: ITokenomics;
  status: SwapStatus = SwapStatus.not_started;
  raisedPercent!: string;
  modeName!: string;
  tokenName = environment.tokenName;
  raisedInfo: RaisedInfo = {
    raisedPercent: "0%",
    usdRaised: 0,
    userClaimable: 0,
    userEthClaimable: 0,
    userStaked: 0,
    maxAmount: 0,
  };

  constructor(
    @Inject(PLATFORM_ID) private _platformId: Object,
    @Inject(WINDOW) private window: Window,
    private eventService: EventService,
    private modalService: BsModalService,
    private dataService: PresaleDataService,
    private modalRef: BsModalRef,
    private analyticsService: AnalyticsService,
    private purchaseService: EvmPurchseService,
    private popupService: PopupService,
    private translate: TranslateService,
  ) {

    this.dataService.$widgetBalanceData.subscribe((data) => {
      this.getBalanceData()
    })
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this._platformId)) { }
  }

  getBalanceData() {
    const balanceData: IBalnceDataEVM = this.dataService.balanceDataEVM;
    const solBalanceData: IBalnceDataSOL = this.dataService.balanceDataSOl;
    const isEVM = this.dataService.activeChain === CHAINS.EVM;
    this.currentStep = balanceData.currentStep;
    this.tokenSold = isEVM ? (balanceData.totalTokensSold || 0) : (solBalanceData.totalTokensSoldSOL || 0);
    this.currentStoreData = this.dataService.tokenomics[this.currentStep];
    this.maxAmount = this.currentStoreData?.maxAmount || 0;
    this.maxToken = this.currentStoreData?.maxToken || 0;
    this.minToken = this.currentStoreData?.minToken || 0;
    this.usdRaised = (balanceData.totalUsdRaised ?? 0) + (solBalanceData.usdRaised ?? 0);
    this.userStaked = this.dataService.userStaked;
    this.userClaimable = isEVM ? balanceData.totalClaimable : solBalanceData.userClaimableSOL;
    this.userEthClaimable = balanceData.ethClaimable ?? 0;
    this.referUrl = this.analyticsService.referUrl;
    // this.status = this.walletConnectService.swapStatus;
    this.walletAddress = isEVM ? this.dataService.walletAddress : this.dataService.walletAddressSOL;
    this.modeName = getChainData(this.dataService.chainId).purchaseToken;
    this.salePrice = this.currentStoreData?.tokenUSDT;
    this.raisedPercent = '0%';//this.getRaisedPercent();
    this.dataLoaded = true;


    this.raisedInfo = {
      raisedPercent: this.raisedPercent,
      usdRaised: this.usdRaised,
      userClaimable: this.userClaimable,
      userEthClaimable: this.userEthClaimable,
      userStaked: this.userStaked,
      maxAmount: this.maxAmount,
    };

  }

  connectModal(placement: 'Widget-Crypto' | 'Widget-Card'): void {
    this.analyticsService.vwoData('walletConnectionPlacement', { placement });
    this.dataService.connectWallet();
  }


  getRaisedPercent() {
    let percent = (this.usdRaised / this.maxAmount) * 100;
    return (percent >= 100 ? 100 : percent) + '%';
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  setTimer() {
    console.log("DATA", this.currentStoreData)
    if (this.dataLoaded) {
      // this.eventService.setCounter(this.communityPhaseCountDown);
      // clearInterval(this.timeInterval);
      if (this.tokenSold && this.tokenSold > 0) {
        if (this.currentStoreData.endDate < Date.parse(new Date().toString()) && this.currentStep < this.dataService.tokenomics.length - 1) {
          this.eventService.setCounter(this.dataService.tokenomics[this.currentStep + 1].endDate);
        } else {
          this.eventService.setCounter(this.currentStoreData.endDate);
        }
        clearInterval(this.timeInterval);
      }
    }
  }

  connectWallet(mode: string): void {
    this.dataService.connectWallet();
    this.modalRef.hide();
  }

  openBestWallet() {
    this.modalRef.hide();
    this.analyticsService.vwoData('dontHaveWallet', { noWalletOptionClickedDevice: getUserDevice(), noWalletOptionClickedPlacement: 'Widget' });
    setTimeout(() => {
      this.modalRef = this.modalService.show(NoWalletComponent, {
        class: 'modal-lg modal-dialog-centered bw-modal',
        backdrop: 'static',
      });
    }, 500);
  }

  checkEthChain() {
    if (this.dataService.chainId === environment.eth.chainIdInt) {
      return true;
    } else {
      this.popupService
        .messagePopup({
          icon: 'info',
          title: this.translate.instant('popup.change_network'),
          desc: this.translate.instant('popup.wrong_chain', { chainName: environment.eth.chainName }),
          confirmBtnTxt: this.translate.instant('misc.ok'),
        })
        .subscribe({
          next: (res: boolean) => {
            if (res) {
              this.dataService.switchNetwork(environment.eth.chainIdInt);
            }
          },
        });
      return false;
    }
  }

  claimToken(): void {
    if (this.userClaimable > 0 && this.checkEthChain()) {
      this.modalRef = this.modalService.show(ClaimComponent, {
        class: 'modal-xs modal-dialog-centered',
        backdrop: 'static',
        initialState: { isStake: false },
      });
      this.purchaseService.claimToken();
    }
  }
}
